import { render, staticRenderFns } from "./SettlementDashboard.vue?vue&type=template&id=8f22208e"
import script from "./SettlementDashboard.vue?vue&type=script&lang=js"
export * from "./SettlementDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports